import { InsurancePlan, InsurancePlanTier } from '@/catalog/types';
import { getDynamicCurrency } from '@/util-conversion/currency';
import Spacer from '@/common/components/spacer';
import Check from '@/icons/check';
import { useSubmit } from 'react-router';
import { useEffect } from 'react';

interface InsurancePackageHiddenInputProps {
  insurancePlans?: InsurancePlan[];
  currentInsurancePlanTier?: InsurancePlanTier;
}

export default function InsurancePackageHiddenInput({
  insurancePlans,
  currentInsurancePlanTier,
}: InsurancePackageHiddenInputProps) {
  const submit = useSubmit();

  const insurancePlan = insurancePlans?.find(
    (plan) => plan.tier === currentInsurancePlanTier
  );

  useEffect(() => {
    if (insurancePlan) {
      submit(
        { intent: 'update_selected_insurance_plan', insurance_plan_id: insurancePlan.id },
        { method: 'post' }
      );
    }
  }, [insurancePlan, submit]);

  if (!insurancePlan) {
    return undefined;
  }

  return (
    <div className="flex flex-col gap-2 rounded-[16px] bg-flexcar-neutral90 p-4 ring-flexcar-neutral80">
      <div className="flex flex-row justify-between">
        <div className="flex flex-row items-center justify-center gap-3">
          <input
            hidden={true}
            readOnly={true}
            name="insurance_plan_id"
            value={insurancePlan.id}
          />
          <p className="body-strong">{insurancePlan.name}</p>
        </div>
        <p className="body">{getDynamicCurrency(insurancePlan.price_per_month)}/mo</p>
      </div>
      <Spacer variant="height12" />
      <div className="flex flex-col gap-1">
        {insurancePlan.details.map((detail) => (
          <div className="flex items-center gap-2" key={detail}>
            <Check />
            <p className="body2">{detail}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
